import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { NotificationItem } from '@/types/common/ui';

export const useNotificationStore = defineStore('notification', () => {
  /**
   * 消息数据类型
   */
  const msgData = ref<NotificationItem[]>([]);
  /**
   * 未读消息
   */
  const unreadMsg = computed(() => msgData.value.filter((item: NotificationItem) => item.status));
  /**
   * 已读消息
   */
  const readMsg = computed(() => msgData.value.filter((item: NotificationItem) => !item.status));

  function setMsgData(data: NotificationItem[]) {
    msgData.value = data;
  }

  return {
    msgData,
    unreadMsg,
    readMsg,
    setMsgData,
  };
});
